import React, { useEffect, useState } from "react";
import { emailValidation, notEmptyValidation, urlValidation } from "../../../functions/validations";
import { CircularProgress } from "@mui/material";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";

const InputText = (props) => {
  const {
    placeholder,
    label,
    value,
    onChange,
    name,
    validation,
    errorText,
    hideLabel,
    className,
    notRequired,
    size = "md",
    onKeyDown,
    feedback,
    feedbackText,
    disabled,
    style,
    onBlur,
  } = props;

  const [error, seterror] = useState(null);

  function checkValidation() {
    if (validation === "ne") {
      if (notRequired) {
        value && !notEmptyValidation(value) && seterror(errorText ? errorText : "Required Input");
      } else {
        !notEmptyValidation(value) && seterror(errorText ? errorText : "Required Input");
      }
    } else if (validation === "email") {
      if (notRequired) {
        value && !emailValidation(value) && seterror(errorText ? errorText : "Invalid E-mail Address");
      } else {
        !emailValidation(value) && seterror(errorText ? errorText : "Invalid E-mail Address");
      }
    } else if (validation === "url") {
      if (notRequired) {
        value && !urlValidation(value) && seterror(errorText ? errorText : "Invalid URL");
      } else {
        !urlValidation(value) && seterror(errorText ? errorText : "Invalid URL");
      }
    } else {
      seterror(null);
    }
  }

  useEffect(() => {
    value && checkValidation();
  }, [validation]);

  return (
    <div className={`input-text ${size} ${error ? "input-error" : ""} ${className}`} style={style}>
      {!hideLabel && <p className="label">{label ? label : placeholder}</p>}
      <div className="input">
        <input
          type="text"
          placeholder={error ? error : placeholder}
          value={value}
          onChange={(e) => {
            error && seterror(null);
            onChange(e);
          }}
          name={name}
          onBlur={() => {
            checkValidation();
            onBlur && onBlur();
          }}
          onKeyDown={onKeyDown}
          disabled={disabled}
        />
        {feedback && (
          <div className="icon-right">
            {feedback === "loading" ? (
              <CircularProgress size="1.5rem" />
            ) : feedback === "success" ? (
              <CheckRoundedIcon className="green" />
            ) : feedback === "error" ? (
              <ErrorOutlineRoundedIcon className="red" />
            ) : null}
          </div>
        )}
      </div>
      {feedbackText && (feedback === "success" || feedback === "error") && (
        <div className="flex mt-1">
          <p className={`${feedback === "success" ? "green" : feedback === "error" ? "red" : ""} bold fs-sm`}>
            {feedbackText}
          </p>
        </div>
      )}
    </div>
  );
};

export default InputText;
